import React, { useEffect } from "react"
import { Row, Col, Dropdown } from "react-bootstrap"
import * as Yup from "yup"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"
import {
  updateValidFormData,
  updateUiData,
  selectDocument,
  getDropdownData,
  updateDropdown,
} from "../redux/actions"
import FormLabel from "../components/shared/formLabel"
import FormRadioButtonOptions from "../components/shared/formRadioButtonOptions"
import Dropzone from "../components/dropzone"
import * as Constants from "../common/constants"
import { navigateToDeceasedDetail, navigateToError } from "../common/function"
import * as ErrorMessage from "../common/errorMessage"
import {
  missingSelectNatureOrOccurAlert,
  clearAllDataWarning,
} from "../services/sweetalertService"
import * as API from "../services/httpService"

const SupportingDocument = () => {
  const uiData = useSelector(state => state.uiData)
  const claimData = useSelector(state => state.claimData, shallowEqual)
  const dispatch = useDispatch()
  const formRef = React.useRef()

  const { claimUploadListModel, pageNumber, lockUploadDropdown } = uiData
  let { proofDocuments } = uiData
  const previewsContainer = "BasicDocumentPreview"

  //death nature options
  let OPT_ACCIDENT_CAUSE = "Accident or Unnatural Cause"
  let OPT_ILLNESS = "Illness"

  const policeReportDocumentId = 385
  const policeReportDocumentObject = {
    coverageDetailId: 160,
    documentId: 385,
    description:
      "Copy of Police Report, Post Mortem, Toxicology and Coroner's Report",
    mandatory: true,
  }

  function HideShowDocuments(deathNature) {
    if (deathNature && deathNature == OPT_ACCIDENT_CAUSE) {
      let indexToRemove = proofDocuments.findIndex(
        x => x.documentId == policeReportDocumentId
      )
      if (indexToRemove == -1) {
        //If cannot found police report in array then add police report
        //Add to certain index
        const indexToInsertPoliceReport = 5
        proofDocuments = [
          ...proofDocuments.slice(0, indexToInsertPoliceReport),
          policeReportDocumentObject,
          ...proofDocuments.slice(indexToInsertPoliceReport),
        ]
      }
    } else {
      proofDocuments.forEach(function(item, index, object) {
        if (item.documentId === policeReportDocumentId) {
          object.splice(index, 1)
        }
      })
    }
  }

  function DropdownValueChange(documentId, documentDesc) {
    dispatch(selectDocument(documentId, documentDesc))
  }

  function checkDocumentStatus(documentId) {
    var hasExists = claimUploadListModel.filter(doc => {
      return doc.documentId === documentId
    })

    return hasExists.length > 0
  }

  const checkMandatoryUploadDocument = () => {
    let mandatoryList = []

    mandatoryList = proofDocuments.filter(x => x.mandatory)

    let isUploaded = false

    //reversed for loop, because splice function inside loop
    for (let i = mandatoryList.length - 1; i >= 0; --i) {
      isUploaded = false
      claimUploadListModel.forEach(
        (currentCoverageItem, currentCoverageKey) => {
          if (
            !isUploaded &&
            mandatoryList[i].documentId === currentCoverageItem.documentId
          ) {
            mandatoryList.splice(i, 1)
            isUploaded = true
          }
        }
      )
    }
    //If mandatoryList is empty will pass mandatory file validation
    return mandatoryList.length < 1 ? true : false
  }

  const createLifeDocumentsList = () => {
    let lifeDocumentsArray = []

    proofDocuments.map((item, index) => {
      lifeDocumentsArray.push(
        <Row
          key={`list_${index}`}
          className="mt-3 paddingLeft15px paddingRight15 unsetMarginTopBottom"
        >
          <Col
            xs={12}
            md={12}
            className={
              "marginTop10px CheckBox documentUpload" +
              (checkDocumentStatus(item.documentId)
                ? " documentSelectedText"
                : "")
            }
          >
            <div>
              {item.description +
                " - " +
                (item.mandatory ? "Required" : "if any")}
            </div>
          </Col>
        </Row>
      )

      return null
    })
    return lifeDocumentsArray
  }

  const createLifeDocumentsDropdownList = () => {
    let lifeDocumentsDropdownArray = []
    proofDocuments.map((item, index) => {
      lifeDocumentsDropdownArray.push(
        <React.Fragment key={`dropdown_${index}`}>
          <Dropdown.Item
            onClick={DropdownValueChange.bind(
              this,
              item.documentId,
              item.description
            )}
            className={
              "dropdown-item DropdownItem AddTripDocumentClass " +
              (lockUploadDropdown ? "disabled" : "")
            }
          >
            {item.description}
          </Dropdown.Item>
          <Dropdown.Divider />
        </React.Fragment>
      )

      return null
    })
    return lifeDocumentsDropdownArray
  }

  const formikSchema = Yup.object().shape({
    deathNature: Yup.string().required(ErrorMessage.deathNature),
  })

  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimLifeDetailModel"])}
      enableReinitialize={true}
      validationSchema={formikSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {
        const GetMaritalStatusPromise = API.apiPostRequest(
          "/Claim/CommonDropDownList",
          null,
          {
            params: {
              name: Constants.maritalStatusTableName,
            },
          }
        )
        const GetRelationshipPromise = API.apiPostRequest(
          "/Claim/CommonDropDownList",
          null,
          {
            params: {
              name: Constants.relationshipTableName,
            },
          }
        )
        const GetLifeClaimantPromise = API.apiPostRequest(
          "/Claim/CommonDropDownList",
          null,
          {
            params: {
              name: Constants.lifeClaimantRelationship,
            },
          }
        )

        Promise.all([
          GetMaritalStatusPromise,
          GetRelationshipPromise,
          GetLifeClaimantPromise,
        ])
          .then(promiseValues => {
            batch(() => {
              if (promiseValues[0].data) {
                dispatch(
                  updateDropdown(
                    promiseValues[0].data.TableName,
                    promiseValues[0].data.CodeTables
                  )
                )
              }
              if (promiseValues[1].data) {
                dispatch(
                  updateDropdown(
                    promiseValues[1].data.TableName,
                    promiseValues[1].data.CodeTables
                  )
                )
              }
              if (promiseValues[2].data) {
                dispatch(
                  updateDropdown(
                    promiseValues[2].data.TableName,
                    promiseValues[2].data.CodeTables
                  )
                )
              }

              dispatch(updateValidFormData("claimLifeDetailModel", values))
              dispatch(updateUiData("showLoading", true))
              dispatch(updateUiData("maxPageNumber", 4))
              navigateToDeceasedDetail()
            })
          })
          .catch(error => {
            navigateToError()
          })
      }}
    >
      {({ handleSubmit, isSubmitting, isValid, values, errors, dirty }) => (
        <FormikForm
          onSubmit={handleSubmit}
          className={pageNumber === 3 ? "" : "hide"}
        >
          <Row>
            <div className="title text-center">Death e-Claims</div>
            <div className={"containerBody"}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <Field
                  className={"fieldTextBold"}
                  textDesc="Select the nature of death"
                  name="deathNature"
                  options={[OPT_ILLNESS, OPT_ACCIDENT_CAUSE]}
                  component={FormRadioButtonOptions}
                />
                {/* 
                ---- Remove on 04/07 ----
                <Field
                  className={"fieldTextBold"}
                  textDesc="Where did the death occur?"
                  name="deathOccur"
                  options={[OPT_OVERSEAS, OPT_SINGAPORE]}
                  component={FormRadioButtonOptions}
                /> */}
              </Col>

              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer paddingTop0px"
              >
                <div className={"titleText "}>Upload Supporting Documents</div>
              </Col>
              <div className="formNoteSection">
                <span className="highlight-text">PLEASE NOTE:</span> Etiqa’s
                Representatives may contact you and request to present to Etiqa
                the certified copy of the documents.
              </div>

              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer paddingTop0px"
              >
                <div className="marginTop20px">
                  <p className={"fontSize14px"}>
                    Notes:
                    <br />
                    a) Please certify true copy of the death certificate at the
                    Singapore Embassy or Notary Public of the Country where the
                    insured passed away (if death is outside Singapore)
                    <br />
                    b) Submit a copy of the letter from ICA confirming the
                    invalidation of Deceased's Singapore NRIC (if death is
                    outside Singapore).
                    <br />
                    c)The documents required is not intended to be exhaustive.
                    We reserve our rights to request for additional documents
                    for claim assessment, if necessary.
                  </p>
                  <FormLabel
                    text={"List of documents required:"}
                    className={"fieldTextBold"}
                  />
                </div>
                {HideShowDocuments(values.deathNature)}
                {createLifeDocumentsList()}
                <br />
                <Row className="paddingLeft15px paddingRight15">
                  <Col
                    xs={{ span: 12, offset: 0 }}
                    md={{ span: 12, offset: 0 }}
                    className="formContainer SupportingDocumentsUploadArea paddingTop0px"
                  >
                    <div>
                      <FormLabel
                        text={"Upload documents"}
                        className={"fieldTextBold"}
                      />

                      <div className={"textforinput marginTop10px"}>
                        <p className={""}>
                          Please note: Total file size should not exceed 10MB.
                        </p>
                      </div>

                      {uiData.exceededFileSizeLimit && (
                        <div className={"textforinput marginTop10px"}>
                          <p className={"colorRed"}>
                            Has exceeded the 10MB total file size limit. Please
                            reupload another file with smaller size.
                          </p>
                        </div>
                      )}
                      {pageNumber >= 3 && (
                        <>
                          <Row>
                            <Dropdown className="dropdown col-10 marginTop10px">
                              <Dropdown.Toggle
                                id="dropdown-basic"
                                className="btn btn-secondary dropdown-toggle DropdownHeader"
                              >
                                {uiData.tempSelectedDocument.documentDesc}
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="dropdown-menu DropdownMenu">
                                {createLifeDocumentsDropdownList()}
                              </Dropdown.Menu>
                            </Dropdown>

                            <Dropzone
                              uiData={uiData}
                              previewsContainer={previewsContainer}
                            />
                          </Row>
                          <Row>
                            <div
                              id={previewsContainer}
                              style={{
                                width: "auto !important",
                                border: "transparent !important",
                                display: "contents",
                              }}
                              className={"dropzone "}
                            ></div>
                          </Row>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            </div>
          </Row>
          <Row>
            <div className={"containerFooter marginTop3x"}>
              <div
                onClick={() => {
                  clearAllDataWarning(
                    uiData.claimUploadListModel,
                    uiData.folderName,
                    dispatch
                  )
                  // navigateToIndex()
                }}
                className="btnBack fontWeightBold"
                // disabled={!isValid || dirty}
              >
                <b>Back</b>
              </div>
              <button
                className={
                  "btnSubmitForm fontWeightBold float-right " +
                  (checkMandatoryUploadDocument() ||
                  process.env.NODE_ENV === "development"
                    ? ""
                    : "d-none")
                }
                type="submit"
                // disabled={isSubmitting}
              >
                <b>Details of Deceased</b>
              </button>
            </div>
          </Row>
          <HandleFormSubmit formRef={formRef} isSubmitting={isSubmitting} />
        </FormikForm>
      )}
    </Formik>
  )
}

const HandleFormSubmit = ({ formRef, isSubmitting }) => {
  React.useEffect(() => {
    if (isSubmitting) {
      formRef.current.validateForm().then(errors => {
        if (Object.entries(errors).length !== 0) {
          missingSelectNatureOrOccurAlert()
          formRef.current.setSubmitting(false)
        }
      })
    }
  }, [isSubmitting])
  return null
}
export default SupportingDocument
